import api from "../../../api";

const API_URL = "/crm/proposals";

// API untuk generate proposal code berdasarkan format number
export async function generateProposalCode() {
  const res = await api.post(`${API_URL}/generate-code`);
  return res.data;
}

// API untuk mendapatkan format number untuk proposal
export async function getFormatNumberForProposal() {
  const res = await api.get('/crm/format-numbers/module/Proposal');
  return res.data;
}

// API untuk update current number setelah generate code
export async function updateFormatNumberCurrentNumber(formatNumberId, currentNumber) {
  const res = await api.put(`/crm/format-numbers/${formatNumberId}/current-number`, {
    currentNumber: currentNumber
  });
  return res.data;
}

// API untuk membuat proposal baru
export async function createProposal(proposalData) {
  const res = await api.post(API_URL, proposalData);
  return res.data;
}

// API untuk mengupdate proposal yang sudah ada
export async function updateProposal(proposalId, proposalData) {
  const res = await api.put(`${API_URL}/${proposalId}`, proposalData);
  return res.data;
}

// Fetch active exchange rate for a given currency code on a specific date.
// Pass proposalCreatedAt (YYYY-MM-DD) for existing proposals; omit to use today.
export async function getActiveCurrencyRate(currencyCode, rateDate) {
  if (!currencyCode || currencyCode.toUpperCase() === 'IDR') return 1;
  try {
    const date = rateDate || new Date().toISOString().split('T')[0];
    const res = await api.get(`/crm/currency-rates/active`, { params: { currencyCode, date } });
    return Number(res.data?.exchange_rate || res.data?.exchangeRate || 1);
  } catch {
    return 1;
  }
} 